<template>
  <div class="Inbound">
    <div class="page-title">{{ title }}</div>
    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          v-model="searchWord"
          class="input-with-select"
          size="mini"
          style="width: 300px;"
          :placeholder="placeholder"
          :disabled="inboundBusy"
          clearable
          @keydown.enter.native="handleClickFilter"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleClickFilter"
          />
        </el-input>

        <div class="inline ml-default" style="width: 100px;">
          <el-select
            size="mini"
            v-model="search_foreign_flag"
            :disabled="inboundBusy"
            @change="onChangeForeignFlag"
          >
            <el-option :key="null" :value="null" label="거래처 구분" />
            <el-option key="N" value="N" label="국내" />
            <el-option key="Y" value="Y" label="해외" />
          </el-select>
        </div>
        <div class="right-search-head inline" style="margin-left: 10px">
          <div class="inline">
            <APeriodSelector
              ref="period"
              value="1w"
              :disabled="inboundBusy"
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >검색(F5)</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row-splitter">
      <ATable
        ref="table_contract"
        max-height="338px"
        v-loading="loading_contract"
        :data="filterDataContract"
        :cell-style="cellStyleOrder"
        hide-button-insert
        hide-pagination
        border
        @selection-change="contractSelectionChange"
      >
        <div slot="search" class="list-title">
          발주 리스트
        </div>
        <el-table-column
          type="selection"
          label="선택"
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column prop="code" label="발주번호" width="100" />
        <el-table-column
          prop="order_inbound_state"
          label="입고 상태"
          width="100"
          :formatter="formatInboundState"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목명"
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :label="$t('lang.size')"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column prop="unit_name" label="단위" width="50" />
        <el-table-column
          prop="amount"
          label="발주량"
          class-name="cell-number"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="remain_amount"
          label="잔량"
          class-name="cell-number"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="delay_flag"
          label="상태"
          :formatter="resolveStatusOrder"
          width="100"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            type="primary"
            :disabled="
              inboundBusy || contractSelection.length < 1 || !has_grant_write
            "
            @click="handleClickSaveSale"
            >입고 등록</el-button
          >
        </div>
      </ATable>
    </div>

    <div class="row-splitter">
      <ATable
        ref="table_sale"
        buttons-width="640px"
        max-height="365px"
        v-loading="loading_sale"
        :data="filterDataSale"
        :default-sort="{ prop: 'code', order: 'ascending' }"
        hide-button-insert
        hide-pagination
        border
        @selection-change="saleSelectionChange"
      >
        <div slot="search" class="list-title">입고 리스트</div>
        <el-table-column
          type="selection"
          label="선택"
          align="center"
          :width="$width.selection"
        />
        <el-table-column type="index" label="No" :index="handleIndexSale" />
        <el-table-column prop="code" label="입고번호" width="100" />
        <el-table-column prop="order_code" label="발주번호" width="100" />
        <el-table-column
          prop="order_inbound_state"
          width="100"
          :formatter="formatInboundState"
        >
          <template slot="header">
            <el-tooltip :content="inboundStateHelp" placement="top">
              <span>입고 상태 <i class="el-icon-question"/></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="inbound_date"
          label="매입일"
          :width="$width.date"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목명"
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :label="$t('lang.size')"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column prop="unit_name" label="단위" width="50" />
        <el-table-column
          prop="amount"
          label="입고량"
          width="80"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <!-- <el-table-column prop="pay_way_flag" label="결제방법" width="100">
          <template slot-scope="scope">
            <el-select
              size="mini"
              class="block"
              v-model="scope.row.pay_way_flag"
              @change="updatePayWay(scope.row)"
            >
              <el-option
                v-for="item in pay_way_flag_options"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="order_date"
          label="발주일"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            :disabled="
              inboundBusy || saleSelection.length < 1 || !has_grant_write
            "
            @click="handleClickBulkChange"
            >{{ $t("button.bulk_change") }}</el-button
          >
          <el-button
            :disabled="inboundBusy || !has_grant_write"
            @click="handleClickInsertSale"
            >수기 매입</el-button
          >
          <el-button
            type="danger"
            :disabled="
              inboundBusy || saleSelection.length < 1 || !has_grant_write
            "
            @click="handleClickDeleteItems"
            >입고 단위 입고 취소</el-button
          >
          <el-button
            type="danger"
            :disabled="
              inboundBusy || saleSelection.length < 1 || !has_grant_write
            "
            @click="handleClickDeleteSale"
            >발주 단위 입고 취소</el-button
          >
        </div>
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      :width="showPyungProcessingCost ? '1500px' : '1300px'"
      title="수기 매입"
      :visible.sync="dialogVisible"
      destroyOnClose
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <InboundForm ref="form" :data="form_data" @completed="handleCompleted" />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="400px"
      destroyOnClose
      :title="$t('button.bulk_change')"
      :visible.sync="dialog2Visible"
      :close-on-click-modal="false"
    >
      <InboundBulkChange
        v-if="dialog2Visible"
        :ids="selectionIds"
        @completed="handleCompletedBulkChange"
      />
    </el-dialog>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { company_info } from "@/common/mixins/company_info";
import { inbound_process } from "@/common/mixins/inbound_process";
import InboundForm from "./InboundForm";
import InboundBulkChange from "./InboundBulkChange";

export default {
  name: "Inbound",
  mixins: [form_container, authority_level, company_info, inbound_process],
  components: { InboundForm, InboundBulkChange },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false
      },
      title: this.$t("title.inbound"),
      period: {},
      placeholder: "발주번호, 거래처, 품목명",
      search_field: ["code", "order_code", "customer_name", "product_name"],
      searchWord: null,
      fixedSearchWord: "",
      dialogVisible: false,
      dialog2Visible: false,
      loading_contract: false,
      items_contract: [],
      contractSelection: [],
      loading_sale: false,
      items_sale: [],
      saleSelection: [],
      form_data: undefined,
      search_foreign_flag: null,
    };
  },
  computed: {
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    /* 발주 */
    filterDataContract: function() {
      return this.util.filterMultiFields(
        this.items_contract,
        this.search_field,
        this.fixedSearchWord,
        this.search_foreign_flag
      );
    },
    /* 입고 */
    filterDataSale: function() {
      return this.util.filterMultiFields(
        this.items_sale,
        this.search_field,
        this.fixedSearchWord,
        this.search_foreign_flag
      );
    },
    pay_way_flag_options: function() {
      return this.system.options.pay_way_flag;
    },
    selectionIds() {
      if (this.saleSelection.length < 1) {
        return [];
      }
      return this.saleSelection.map((s) => s.id);
    },
    has_grant_write() {
      return this.isWriteLevel("inbound");
    },
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  mounted() {
    this.loadConfig()
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      // 입고 등록/취소 중이거나 취소 확인 중에는 목록을 다시 불러오지 않는다.
      if (this.inboundBusy) {
        return;
      }
      if (!this.period.valid) {
        return;
      }
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.loadData();
    },
    handleClickFilter() {
      if (this.inboundBusy) {
        return;
      }
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.fixedSearchWord = this.searchWord;
    },
    loadInboundOrder() {
      if (this.inboundBusy) {
        return;
      }
      this.loading_contract = true;
      this.api.listInboundOrder(this.period).then((res) => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_contract = res.data;
      });
    },
    loadData() {
      if (this.inboundBusy) {
        return;
      }
      this.loadInboundOrder();
      this.loadInbound();
    },
    loadInbound() {
      if (this.inboundBusy) {
        return;
      }
      this.loading_sale = true;
      this.api.listInbound(this.period).then((res) => {
        this.loading_sale = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_sale = res.data;
      });
    },
    compareContract() {
      return function(a, b) {
        if (a.code < b.code) {
          return -1;
        } else if (a.code === b.code) {
          return a.seq - b.seq;
        } else {
          return 1;
        }
        // const value1 = a[property];
        // const value2 = b[property];
        // return value1 - value2;
      };
    },
    cellStyleOrder({ row, column /*, rowIndex, columnIndex*/ }) {
      if (column.property === "delay_flag") {
        if (row["valid_date"] < this.util.getDateString()) {
          return { color: "red" };
        }
      }

      return null;
    },

    contractSelectionChange(selection) {
      this.contractSelection = selection;
    },
    saleSelectionChange(selection) {
      this.saleSelection = selection;
    },
    handleCurrentChangeContract(value) {
      this.currentPageContract = value;
    },
    handleCurrentChangeSale(value) {
      this.currentPageSale = value;
    },

    // updateAmount(item) {
    //   if (item.amount < 1) {
    //     this.util.notify_warning(this, this.title, "수량은 0보다 커야 합니다.");
    //     return;
    //   }
    //   let amount = Number.parseFloat(item.amount);
    //   let data = { id: item.id, amount: amount };
    //   this.api.updateInboundAmount(data).then(res => {
    //     if (res.error !== this.system.noError) {
    //       this.util.notify_response_error(this, this.title, res);
    //       return;
    //     }

    //     this.util.notify_warning(this, this.title, "저장되었습니다.");
    //     this.loadInboundOrder();
    //   });
    // },
    handleIndex(index) {
      return this.$refs.table_contract.indexResolver(index);
    },
    handleIndexSale(index) {
      return this.$refs.table_sale.indexResolver(index);
    },

    handleClickSaveSale() {
      if (this.contractSelection.length < 1) {
        this.util.notify_warning(
          this,
          this.title,
          this.$t("message.no_selection")
        );
        return;
      }
      if (this.inboundBusy) {
        return;
      }
      let params = this.contractSelection.map((item) => item.id);
      params.sort(function(a, b) {
        return a - b;
      });
      // 성공/실패와 관계없이 목록을 다시 불러와 선택을 초기화한다.
      this.registerInboundByChunk(params).then(() => this.handleClickSearch());
    },
    /** 발주 단위 입고 취소: 선택한 입고가 속한 발주의 모든 입고를 취소한다. */
    handleClickDeleteSale() {
      return this.cancelInbound("order");
    },
    /** 입고 단위 입고 취소: 선택한 입고만 취소한다. */
    handleClickDeleteItems() {
      return this.cancelInbound("item");
    },
    /** 목록을 만든 조회 기간과 검색 조건 */
    listCondition() {
      return JSON.stringify([
        this.period.startDate,
        this.period.endDate,
        this.fixedSearchWord,
        this.search_foreign_flag,
      ]);
    },
    cancelInbound(unit) {
      if (!this.has_grant_write) {
        return;
      }
      // 확인하는 사이 조회 기간이나 검색 조건이 바뀌었으면 요청하지 않는다.
      const condition = this.listCondition();
      return this.cancelInboundWithConfirm(this.saleSelection, unit, {
        isValid: () => this.listCondition() === condition,
        // 성공/실패와 관계없이 상단·하단 목록을 다시 불러와 선택을 초기화한다.
        reload: () => {
          this.contractSelection = [];
          this.saleSelection = [];
          this.handleClickSearch();
        },
      });
    },

    resolveStatusOrder(row) {
      return row["valid_date"] < this.util.getDateString() ? "지연" : "진행";
    },
    // updatePayWay(item) {
    //   let data = { id: item.id, pay_way_flag: item.pay_way_flag };
    //   this.api.updateInboundUnpaidPayWay(data).then(res => {
    //     if (res.error !== this.system.noError) {
    //       this.util.notify_response_error(this, this.title, res.message);
    //       return;
    //     }
    //     this.util.notify_success(this, this.title, "저장되었습니다.");
    //   });
    // },
    handleClickInsertSale() {
      if (this.inboundBusy) {
        return;
      }
      this.dialogVisible = true;
    },
    handleCompleted(result) {
      this.dialogVisible = false;
      this.form_data = undefined;
      if (!result) {
        return;
      }
      this.loadInbound();
    },
    handleClickBulkChange() {
      if (this.inboundBusy) {
        return;
      }
      this.dialog2Visible = true;
    },
    handleCompletedBulkChange(result) {
      this.dialog2Visible = false;
      if (!result) {
        return;
      }
      this.loadInbound();
    },
  },
};
</script>
